import { FC } from 'react';
import {
	ImageSizePriority,
	SpacerSectionBetweenColumns,
	TextHeadingSection,
} from 'components';
import { Col, Grid, Row } from 'antd';

export const SectionWhatToExpect: FC = () => {
	const { lg, xl } = Grid.useBreakpoint();
	const expectables = [
		[
      'Live stream NFT sales',
			'All live auctions will provide a live stream for viewers and collectors to follow along with our in-house NFT Auctioneer.',
		],
		[
			'Live chat with other members',
			'Drop into the troll box and connect with other influential NFT collectors.',
		],
		[
			'Place bids on your favourite artwork',
			'Something catch your eye? Don’t let it get away as you may never see it up for sale again.',
		],
	] as [string, string][];

	return (
		<Row wrap={!lg} justify={'space-between'}>
			<Col flex={!lg && 'auto'}>
				<ImageSizePriority
					primaryPriority={'width'}
					switchBreakpoint={'lg'}
					src={'/assets/live-auction--expect.png'}
				/>
			</Col>
			<Col flex={xl ? '544px' : lg && '448px'} lg={26}>
				<TextHeadingSection secondary>What to expect</TextHeadingSection>
				<ul>
					{expectables.map(([title, description]) => (
						<li>
							<strong>{title}</strong>
							<p>{description}</p>
						</li>
					))}
				</ul>
			</Col>
		</Row>
	);
};
